<!-- 工单系统  问题追踪系统 有移动端 issue_vue3 -->
<template>
  <div class="work_order_page">

    <!-- 筛选 -->
    <div class="clearfix">
      <el-input v-model.trim="param.productSn" style="width: 200px;" clearable :placeholder="$t('workOrder.device_sn')" class="el-input-item fl" @input="changeSearch" />
      <el-select v-model="param.productType" style="width: 200px;" :placeholder="$t('workOrder.device_type')" class="el-input-item fl" clearable filterable @change="changeSearch">
        <el-option v-for="(item,index) in deviceModelOptions" :key="index" :label="$t('workOrder.'+item.label)" :value="item.value" />
      </el-select>
      <el-select v-model="param.status" style="width: 200px;" :placeholder="$t('workOrder.current_state')" class="el-input-item fl" clearable filterable @change="changeSearch">
        <el-option v-for="(item,index) in statusOptions" :key="index" :label="$t('workOrder.'+item.label)" :value="item.value" />
      </el-select>
      <el-select v-model="param.problemType" style="width: 200px;" :placeholder="$t('workOrder.question_type')" class="el-input-item fl" clearable filterable @change="changeSearch">
        <el-option v-for="(item,index) in problemTypeOptions" :key="index" :label="$t('workOrder.'+item.label)" :value="item.value" />
      </el-select>

      <el-button class="fl" type="primary" icon="el-icon-search" @click="changeSearch" />
      <el-button class="fr" type="primary" icon="el-icon-plus" @click="addProblem" />
    </div>

    <div style="height: 20px;" />
    <el-table :data="tableData" border>
      <el-table-column type="expand" style="border-right: none;" >
        <template slot-scope="scope">
          <rowTemplateBox :raw="scope.row" @edit="toEdit" />
        </template>
      </el-table-column>
      <el-table-column prop="productSn" :label="$t('workOrder.device_sn')" />
      <el-table-column prop="client" :label="$t('workOrder.client')" />
      <el-table-column prop="contactDetails" :label="$t('workOrder.contact_details')" />
      <el-table-column prop="status" :label="$t('workOrder.current_state')">
        <template slot-scope="scope">
          {{ statusName(scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column prop="problemType" :label="$t('workOrder.question_type')">
        <template slot-scope="scope">
          {{ typeName(scope.row.problemType) }}
        </template>
      </el-table-column>
      <el-table-column prop="step1" :label="$t('workOrder.problem_desc')" width="280">
        <template slot-scope="scope">
          {{ scope.row.errorDes }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" :label="$t('workOrder.creation_time')">
        <template slot-scope="scope">
          {{ scope.row.createTime | timeFormat }}
        </template>
      </el-table-column>

      <el-table-column :label="$t('workOrder.operate')" align="center" width="100">
        <template slot-scope="scope">
          <!-- <el-button :type="viewBtnBack(scope.row)" icon="el-icon-view" circle size="mini" @click="openDrawer(scope.row)"/> -->
          <el-button :type="editBtnBack(scope.row)" icon="el-icon-edit" size="mini" @click="openEditDialog(scope.row)" />
        </template>
      </el-table-column>

    </el-table>
    <div style="height: 20px;" />
    <el-pagination :page-size="param.pageSize" :total="total" background :current-page.sync="param.pageNum" layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" />

    <!-- 步骤条展示 -->
    <el-drawer
      title=""
      :visible.sync="isDrawerShow"
      :direction="'rtl'"
    >

      <step-box :raw="raw" @edit="toEdit" />
    </el-drawer>

    <!-- 打开编辑 -->
    <el-dialog
      :title="$t('workOrder.edit_wo')"
      :visible.sync="dialogVisible"
      width="70%"
      @close="initData"
    >
      <edit-problem :id="raw.id" :current="current" :pop-show="dialogVisible" @cancel="dialogVisible = false" @save="submitForm" />

    </el-dialog>

    <!-- 新增工单 -->
    <el-dialog
      :title="$t('workOrder.add_wo')"
      :visible.sync="dialogVisible2"
      width="50%"
      @close="initData"
    >
      <client-form v-if="dialogVisible2" :raw="null" @save="submitForm" @back="dialogVisible2 = false" />

    </el-dialog>

  </div>
</template>

<script>
import { getModuleValueMap } from '@/api'
import { statusOptions, problemTypes } from './options'
import { getProblemPage, saveProblem, configList } from '../../api/workOrder'
import rowTemplateBox from './components/rowTemplateBox.vue'
import StepBox from './components/StepBox.vue'
import EditProblem from './components/EditProblem.vue'
import ClientForm from './components/ClientForm.vue'
export default {
  components: { StepBox, EditProblem, ClientForm, rowTemplateBox },
  filters: {

    stepHandle(val) {
      if (val) {
        const obj = JSON.parse(val)
        var errorDes = '--'
        var configList = this.$storage.get('configList') || []
        this.descriOption = []
        configList.forEach((v, i) => {
          if (v.key == 'faultDescription') { // 故障描述由客服反馈而来
            var arr = (this.$store.state.language == 'zh' ? v.valueList : v.valueEnList) || []
            arr.forEach((m, i) => {
              if (obj.descriptionKey == i) {
                errorDes = i != 3 ? m : obj.description
              }
            })
          }
        })
        return errorDes
      }
      return '--'
    }
  },

  data() {
    return {
      dialogVisible: false,
      dialogVisible2: false,
      isDrawerShow: false,
      param: {
        'client': '',
        'endDate': '',
        'pageNum': 1,
        'pageSize': 10,
        'problemType': '',
        // 'productSn': 'PY20641750',
        'productSn': '',
        'productType': 1,
        'startDate': '',
        'status': ''
      },
      total: 10,
      tableData: [],
      statusOptions: statusOptions,
      problemTypeOptions: problemTypes,
      raw: {},
      current: '',
      deviceModelOptions: [
        { label: 'all', value: '' },
        { label: 'charger', value: 1 }
      ]

    }
  },
  watch: {
    '$i18n.locale'(val) {
      this.getLangOptions()
    }
  },
  mounted() {
    this.initData()
    this.getLangOptions()
    this.getConfigList()// 获取下拉框信息
  },
  methods: {
    viewBtnBack(row) {
      if (row.status == 100) return 'success'
      if (row.status > 100) return 'info'
      return 'primary'
    },
    editBtnBack(row) {
      if (row.status >= 100) return 'info'
      return 'primary'
    },
    getLangOptions() { // 获取国际化数据
      const language = this.$i18n.locale
      if (this.$i18n.messages[language].chargeEvent) return
      getModuleValueMap(language, {
        'module': 'workOrder',
        'project': 'admin2020'
      }).then(res => {
        console.log('国际化数据：', res)
        if (res.resultCode == 1001) {
          this.$i18n.setLocaleMessage(language, Object.assign({ 'workOrder': res.resultModel }, this.$i18n.messages[language]))
        }
      })
    },
    submitForm(form) {
      console.log('提交：', form)
      saveProblem(form).then(res => {
        if (res.resultCode == 1001) {
          this.$message.success(this.$t('workOrder.successfully_saved'))
          this.dialogVisible2 = false
          this.isDrawerShow = this.dialogVisible = false
          this.initData()
        } else {
          if (res.resultMessage == 'problem_exists') {
            this.$message.error(this.$t('workOrder.failed_not_processed'))
            return
          }
          this.$message.error(this.$t('workOrder.submission_failed'))
        }
      })
    },
    addProblem() {
      this.dialogVisible2 = true
    },
    toEdit(current) {
      console.log(current)
      this.current = current
      this.dialogVisible = true
      // this.isDrawerShow = false
    },
    openEditDialog(raw) {
      console.log(raw)
      this.raw = raw
      this.dialogVisible = true
    },
    openDrawer(raw) {
      console.log(raw)
      this.raw = raw
      this.isDrawerShow = true
    },
    changeSearch() {
      this.param.pageNum = 1
      this.initData()
    },
    statusName(val) {
      let name = ''
      this.statusOptions.forEach(item => {
        if (item.value == val) name = item.label
      })
      if (name) {
        return this.$t('workOrder.' + name)
      }
      return '--'
    },
    typeName(val) {
      let name = ''
      this.problemTypeOptions.forEach(item => {
        if (item.value == val) name = item.label
      })
      if (name) {
        return this.$t('workOrder.' + name)
      }
      return '--'
    },
    handleCurrentChange(val) {
      this.param.pageNum = val
      this.initData()
    },
    initData() {
      getProblemPage(this.param).then(res => {
        console.log('工单系统', res)
        if (res.resultCode == 1001) {
          this.tableData = res.resultModel.list
          this.total = res.resultModel.total
          var configList = this.$storage.get('configList') || []
          this.tableData.forEach(v => {
            if (v.step1) {
              const obj = JSON.parse(v.step1)
              v.errorDes = '--'
              configList.forEach((c, i) => {
                if (c.key == 'faultDescription') { // 故障描述由客服反馈而来
                  var arr = (this.$store.state.language == 'zh' ? c.valueList : c.valueEnList) || []
                  arr.forEach((m, i) => {
                    if (obj.descriptionKey == i) {
                      v.errorDes = i != 3 ? m : obj.description
                    }
                  })
                }
              })
            }
          })
        }
      })
    },
    getConfigList() { // 获取下拉框信息
      configList().then(res => {
        this.$storage.set('configList', res.resultModel || [])
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.work_order_page {
  background-color: #fff;
  min-height: 100%;
  padding: 10px 20px;
}
.el-input-item {
  margin-right: 20px;
}
</style>
